/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import { FormattedMessage } from 'react-intl';
import styles from './collapsible.module.scss';
import Clickable from '../clickable/Clickable';


class Collapsible extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.onItemClick = this.onItemClick.bind(this);
    this.content = React.createRef();
    this.transitionStyles = {
      entered: {
        // overflow: 'visible'
      }
    };
    if (props.overflowCustom) {
      this.transitionStyles ={
        entered: {
          overflow: 'visible'
        },
        exited: {
          overflow: 'hidden'
        }
      };
    }
  }

  componentDidMount() {
    const { openOnMount, offset, autoheight, dateFilter, collapsibleHeight } = this.props;
    if (autoheight) {
      this.transitionStyles.entered.maxHeight = this.content.current.scrollHeight + offset;
    } else {
      this.transitionStyles.entered.maxHeight = '100vh';
      this.transitionStyles.entered.overflow = 'auto';
    }
    if (collapsibleHeight !== undefined && collapsibleHeight !== null) {
      this.transitionStyles.entered.maxHeight = collapsibleHeight;
    }
    this.setState({ active: openOnMount });
    if (dateFilter) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentDidUpdate(prevprops) {
    const { openOnMount } = this.props;
    const { active } = this.state;
    if ((prevprops.openOnMount !== openOnMount) && openOnMount !== active) {
      this.setState({ active: openOnMount });
    }
  }

  componentWillUnmount() {
    const { dateFilter } = this.props;
    if (dateFilter) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  onActiveClick =(e) => {
    this.setState({
      active: !e
    });
  }

  onItemClick() {
    this.setState(prevState => ({ active: !prevState.active }));
  }

  handleClickOutside = (event) => {
    const { dateFilter } = this.props;
    const { active } = this.state;
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (active && dateFilter) {
        this.setState({ active: false });
      }
    }
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  }

  render() {
    const { active } = this.state;
    const { children, title, styleClasses, titleNode, adp, titleChildren, dateFilter, inspectionMaxHeight, permit, collapseDesc,
      overflowVisible, defaultMessage, translationValues, badgingOnClick } = this.props;
    const classes = [
      styles.header,
      !styleClasses && styles.title,
      active && styles.open,
      styleClasses
    ].filter(e => e);

    return (
      <div className={styles.collapsible} ref={this.setWrapperRef}>
        <Clickable
        onClick={(e) => {
          if (badgingOnClick) {
            badgingOnClick(e);
          } else {
            this.onItemClick();
          }
        }}
        onActiveClick={this.onActiveClick}
        className={classes.join(' ')} style={{ padding: !adp ?this.props.styles:0,
          fontSize: adp ? '18px' : '',
          marginTop: adp && '2%',
          border: adp?'none':'',
          width: adp? '97%':'' }}
        >
          {titleNode}
          {title && (
            <FormattedMessage
              id={title}
              defaultMessage={defaultMessage || title}
              values={translationValues}
            />
          )}
        </Clickable>
        {titleChildren}
        <Transition in={active} timeout={0}>
          {state => (
            <div ref={this.content}
              className={`${styles.content} ${permit && styles.permitContent}
              ${overflowVisible && !active && styles.overFlowVisible}
              ${dateFilter && styles.dateFilterContent}
              ${(inspectionMaxHeight || collapseDesc) && styles.inspectionMaxHeight}`}
              style={this.transitionStyles[state]}
            >
              {children}
            </div>
          )}
        </Transition>
      </div>
    );
  }
}

Collapsible.defaultProps = {
  styleClasses: '',
  openOnMount: false,
  offset: 0,
  autoheight: true,
  dateFilter: false,
  inspectionMaxHeight: false,
  badgingOnClick: null
};

Collapsible.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  styleClasses: PropTypes.string,
  openOnMount: PropTypes.bool,
  autoheight: PropTypes.bool,
  offset: PropTypes.number,
  dateFilter: PropTypes.bool,
  inspectionMaxHeight: PropTypes.bool,
  badgingOnClick: PropTypes.func
};

export default Collapsible;
